module.exports = __webpack_public_path__ + "img/previcon.cce70a3d.svg";